import { render, staticRenderFns } from "./RegionsFields.vue?vue&type=template&id=4cf6542c&"
import script from "./RegionsFields.vue?vue&type=script&lang=js&"
export * from "./RegionsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports